import React from 'react';
import {
  Flex, Space, Tooltip, Typography,
} from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

const { Text } = Typography;

interface AttributeInfoProps {
  title: string;
  extra: React.ReactNode;
  icon: React.ElementType;
  tooltip?: string;
}

const AttributeInfo = function ({
  title,
  extra,
  icon: Icon,
  tooltip = undefined,
}: AttributeInfoProps) {
  return (
    <Space size={8}>
      <Icon style={{ fontSize: 'clamp(20px, 2.5vw, 30px)' }} />
      <Flex vertical>
        <Text type="secondary">
          <Space>
            {title}
            {tooltip && (
              <Tooltip title={tooltip}>
                <InfoCircleOutlined />
              </Tooltip>
            )}
          </Space>
        </Text>
        {extra}
      </Flex>
    </Space>
  );
};

export default AttributeInfo;
